<div class="position-reletivediv popup-inner-space">
    <div class="betweenheader">
       Threshold Value
    </div>
    <div class="text-right flow-right">
        <img src="assets/images/close.svg" class="img-fluid closeicon2 cursor-pointer" alt="..."
            (click)="Close()">
    </div>

    <form class="" [formGroup]="setparameterForm" (ngSubmit)="OnSubmit()">
        <div class="errmsg" *ngIf="errorMsg">{{errorMsg}}</div>
        <div class="sucessmsg" *ngIf="successMsg">{{successMsg}}</div>
      
        <div *ngIf="Type != 'RMSPRAYAS'" class="row display-flex-container">

            <div class="text-field-container2">
                <div class="fxg-field margin-top-5 col-lg-6">
                    
                        <label for="FirstName" style="display:none;" class="Navuser" id="first-name">Vacuum Transmitter
                           </label>
                        <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                            formControlName="VaccumeTransmitter" id="VaccumeTransmitter" name="VaccumeTransmitter"
                            maxlength="50" required="" title="Vaccume Transmitter" aria-required="true"
                            [ngClass]="{'cursor-pointer-none' : IsreadOnly}" >
                        <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Vacuum
                            Transmitter</span>
                    
                
                </div>

                <div class="fxg-field margin-top-5 col-lg-6">
                    
                <label for="FirstName" style="display:none;" class="Navuser" id="first-name">Vacuum Transmitter
                </label>
             <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                 formControlName="LowLevelTransmitter" id="LowLevelTransmitter" name="LowLevelTransmitter"
                 maxlength="50" required="" title="Low Level Transmitter" aria-required="true"
                 [ngClass]="{'cursor-pointer-none' : IsreadOnly}" >
             <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Low Level Transmitter</span>
                    </div>
                    <div class="fxg-field margin-top-5 col-lg-6">
                    
                <label for="FirstName" style="display:none;" class="Navuser" id="first-name">Calibration
                </label>
             <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                 formControlName="Calibration" id="Calibration" name="LowLevelTransmitter"
                 maxlength="50" required="" title="Low Level Transmitter" aria-required="true"
                 [ngClass]="{'cursor-pointer-none' : IsreadOnly}" >
             <span class="fxg-field__placeholder12 fxg-field__floating-placeholder" tabindex="-1">Calibration</span>
                        </div>

                        
            </div>
        
        </div>
           
        <div class="margin-top-20 save-cancel save-data fixed-button-popup" *ngIf="DisplayButton">
            <button class="btncommon" type="submit">Save</button>
            <button class="btncommon btn-border-add-company23" (click)="OnCancel()">Cancel</button>
        </div>
        <div *ngIf="Type == 'RMSPRAYAS'">
            <div class="fxg-field margin-top-5">
                <label style="display:none;" class="Navuser">Flow Rate
                </label>
                <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                    formControlName="VaccumeTransmitter" id="VaccumeTransmitter" name="VaccumeTransmitter"
                    title="Vaccume Transmitter" NumberWithDecimal maxlength="50" aria-required="true"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
                <span class="fxg-field__placeholder fxg-field__floating-placeholder" tabindex="-1">Flow Rate</span>
            </div>
            <div class="fxg-field margin-top-5">
                <label style="display:none;" class="Navuser">Totalizer
                </label>
                <input type="text" class="fxg-field__input-text fxg-field__input--required sessioncamexclude"
                    formControlName="LowLevelTransmitter" id="LowLevelTransmitter" name="LowLevelTransmitter"
                    title="Low Level Transmitter" NumberWithDecimal maxlength="50" aria-required="true"
                    [ngClass]="{'cursor-pointer-none' : IsreadOnly}">
                <span class="fxg-field__placeholder fxg-field__floating-placeholder" tabindex="-1">Totalizer</span>
            </div>
            <div class="margin-top-20 save-cancel save-data fixed-button-popup fixed-button-popup" *ngIf="DisplayButton">
                <button class="btncommon" type="submit">Save</button>
                <button class="btncommon btn-border-add-company23" (click)="OnCancel()">Cancel</button>
            </div>
        </div>
        
    </form>
</div>